// サイト入場証・管理者トークン共通の保存/取得ロジック。
// 署名の検証はしない（それはサーバー側の役目）。ここでは「明らかに期限切れなら
// 入力画面へ戻す」というUXのための軽い判定だけを行う。

function decodePayload(token) {
  try {
    const [payloadPart] = token.split('.');
    const pad = payloadPart.length % 4 === 0 ? '' : '='.repeat(4 - (payloadPart.length % 4));
    const base64 = payloadPart.replace(/-/g, '+').replace(/_/g, '/') + pad;
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}

/** localStorage/sessionStorageのどちらかと、キー名を渡して使う。 */
export function makeTokenStore(storage, key) {
  return {
    save(token) {
      try { storage.setItem(key, token); } catch { /* 保存できなくても支障なし */ }
    },
    clear() {
      try { storage.removeItem(key); } catch { /* 削除できなくても支障なし */ }
    },
    /** 保存済みトークンを返す。期限切れなら削除してnullを返す。 */
    get() {
      try {
        const token = storage.getItem(key);
        if (!token) return null;
        const payload = decodePayload(token);
        if (!payload || typeof payload.exp !== 'number' || Date.now() / 1000 > payload.exp) {
          storage.removeItem(key);
          return null;
        }
        return token;
      } catch {
        return null;
      }
    },
  };
}
